import { ChevronLeft } from "lucide-react";
import { LucideProps } from "lucide-react";

interface BackIconProps extends LucideProps {
  className?: string;
}

export default function BackIcon({ className = "", size = 24, ...props }: BackIconProps) {
  return <ChevronLeft className={className} size={size} {...props} />;
}
